import { render, staticRenderFns } from "./V2DealPackEdit.vue?vue&type=template&id=9203241a&scoped=true&"
import script from "./V2DealPackEdit.vue?vue&type=script&lang=js&"
export * from "./V2DealPackEdit.vue?vue&type=script&lang=js&"
import style0 from "./V2DealPackEdit.vue?vue&type=style&index=0&id=9203241a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9203241a",
  null
  
)

export default component.exports